import styles from './FJImageManipulationRight.module.less';
import PropTypes from 'prop-types';
import FJDragBox from '../../../common/components/FJDragBox/FJDragBox';
import FJDisplayHeaderContainer from '../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJHistoryPanelContainer from '../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import FJCreationEditPanelContainer from '../../FJMainPreview/FJCreationEditPanel/container/FJCreationEditPanelContainer';
import classNames from 'classnames';
import FJUtil from '../../../util/FJUtil';
import FJLocalStore from '../../../store/FJLocalStore';
import FJConstant from '../../../constants/FJConstant';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton';
import DownloadIcon from '../../../assets/svg/download_black.svg?react';

const FJImageManipulationRight = props => {
    const {
        uploadImg,
        setIsDraggingFile,
        headerTabIndex,
        taskStatus,
        download,
        isCanDownload,
        hasEditImage,
        downloadEditImageLoading,
    } = props;

    const renderDownload = () => {
        if (
            FJUtil.isGeneratingStatus(taskStatus) ||
            taskStatus === FJConstant.ERROR ||
            headerTabIndex !== 0 ||
            !isCanDownload
        ) {
            return null;
        }

        if (window.isEditPage) return null;

        return (
            <div className={styles.download_box}>
                <FJButton
                    onClick={download}
                    className={classNames(styles.download, downloadEditImageLoading && styles.loading)}
                    textClassName={styles.download_text}
                    text={FJLocalStore._('download')}
                    isLoading={downloadEditImageLoading}
                    type={FJButtonType.GRADIENT}
                    icon={<DownloadIcon className={styles.download_icon} />}
                />
            </div>
        );
    };

    return (
        <FJDragBox
            setIsDragging={setIsDraggingFile}
            uploadFile={uploadImg}
            disable={FJUtil.isGeneratingStatus(taskStatus)}
            className={classNames(styles.app_right)}
        >
            <FJDisplayHeaderContainer rightChildren={renderDownload()} hasEditImage={hasEditImage} />

            <FJCreationEditPanelContainer activeHeaderTabIndex={0} />

            <FJHistoryPanelContainer activeHeaderTabIndex={1} />
        </FJDragBox>
    );
};
FJImageManipulationRight.propTypes = {
    uploadImg: PropTypes.func,
    setIsDraggingFile: PropTypes.func,
    headerTabIndex: PropTypes.number,
    taskStatus: PropTypes.string,
    creationList: PropTypes.array,
    download: PropTypes.func,
    downloadEditImageLoading: PropTypes.bool,
    isCanDownload: PropTypes.bool,
    hasEditImage: PropTypes.bool,
};
export default FJImageManipulationRight;
